import { PLATFORM } from 'aurelia-pal';

const odsCalendar = PLATFORM.moduleName('libs/ods/aurelia/odsCalendar/odsCalendar');
const odsDropdown = PLATFORM.moduleName('libs/ods/aurelia/odsDropdown/odsDropdown');
const odsMenu = PLATFORM.moduleName('libs/ods/aurelia/odsMenu/odsMenu');
const odsPagination = PLATFORM.moduleName('libs/ods/aurelia/odsPagination/odsPagination');

export const configure = (aurelia) => {
  aurelia.globalResources(
    odsCalendar,
    odsDropdown,
    odsMenu,
    odsPagination,
  );
};
